import { graphDataText, graphDefault, graphNodeLabel } from './';
export const graphNodeDetails = (theme, parameters) => {
  return {
    textColor: graphNodeLabel(theme, parameters).textColor,
    fontFamily: graphNodeLabel(theme, parameters).fontFamily,
    fontSize: graphDefault(theme, parameters).fontSize.xxxs,
    fontStyle: graphDataText(theme, parameters).fontStyle,
    fontWeight: graphDataText(theme, parameters).fontWeight
  };
};
//# sourceMappingURL=graphNodeDetails.js.map